var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("評価者平均と本人採点")]),_c('div',{ref:"wrapper",staticClass:"all-chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }